import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import equal from 'deep-equal';

import JsonEditor from './JsonEditor';
import Button from '../../Button';
import { newChart } from '../../../containers/App/actions';

export class CdfEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cdf: props.cdf || {},
      valid: true,
    };
  }
  componentWillReceiveProps(newProps) {
    if (!equal(this.state.cdf, newProps.cdf)) {
      // We assume the CDF passed in is always valid, so set valid to true if we receive new props
      this.setState({ cdf: newProps.cdf, valid: true });
    }
  }
  onChange(e) {
    // Check to see if the CDF is valid - don't change it if it is not
    if (e.valid) {
      this.setState({ cdf: e.object, valid: e.valid });
    } else {
      this.setState({ valid: e.valid });
    }
  }
  onClick() {
    if (this.state.valid) {
      this.props.newChart(this.state.cdf);
    }
  }
  render() {
    return (
      <div>
        <JsonEditor object={this.state.cdf} onChange={(e) => this.onChange(e)} />
        <EditorButton disabled={!this.state.valid} onClick={(e) => this.onClick(e)} >Update CDF</EditorButton>
      </div>
    );
  }
}

export function mapDispatchToProps(dispatch) {
  return {
    newChart: (cdf) => {
      dispatch(newChart(cdf));
    },
  };
}

const EditorButton = Button;

CdfEditor.propTypes = {
  cdf: PropTypes.object,
  newChart: PropTypes.func,
};

const withConnect = connect(null, mapDispatchToProps);

export default compose(
  withConnect,
)(CdfEditor);



// WEBPACK FOOTER //
// ./app/components/FormControls/CdfEditor/index.js